import { initializeApp } from 'firebase/app';
import FIREBASE_CONFIG from './FirebaseConfig';

// const app = initializeApp(FIREBASE_CONFIG.easyWeb);
// const app = initializeApp(FIREBASE_CONFIG.selbsthilfe);
// const app = initializeApp(FIREBASE_CONFIG.herzverein);
const app = initializeApp(FIREBASE_CONFIG.seltenerkrebs);
export default app; 